import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const IVO_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_real-estate-varna/artifacts/jq8zrtmd_Screenshot%202026-07-15%20at%2011.58.35.png";

export default function Organizer() {
  return (
    <section data-testid="organizer-section" className="relative bg-[#0B1F3D] text-[#F5EBD9] py-24 lg:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Photo */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-5"
        >
          <div className="relative max-w-md mx-auto lg:mx-0">
            <div className="absolute -inset-3 border border-[#F5892E]/40 rounded-2xl pointer-events-none" />
            <div className="relative overflow-hidden rounded-2xl frame-shadow" style={{ aspectRatio: "4/5" }}>
              <div
                className="w-full h-full bg-cover"
                style={{ backgroundImage: `url(${IVO_PORTRAIT})`, backgroundPosition: "center 12%", backgroundSize: "140% auto", backgroundRepeat: "no-repeat" }}
              />
              <div className="absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-[#0B1F3D] to-transparent pointer-events-none" />
            </div>
            {/* Signature element */}
            <div className="mt-5 font-serif italic text-2xl text-[#E0B95C] text-center lg:text-left">
              — Иво Димовски
            </div>
          </div>
        </motion.div>

        {/* Copy */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="lg:col-span-7"
        >
          <div className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5892E] mb-4 flex items-center gap-4">
            <span className="h-px w-10 bg-[#F5892E]" />
            Човекът зад играта
          </div>
          <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
            Иво Димовски
          </h2>
          <div className="mt-3 font-mono text-[11px] uppercase tracking-[0.26em] text-[#E0B95C]">
            Организатор на „Играта на имотите"
          </div>

          <div className="mt-8 space-y-5 text-lg text-[#C8D4E6] leading-relaxed max-w-[62ch]">
            <p>
              „Играта на имотите" е създадена с амбицията да промени начина, по който говорим за
              недвижимите имоти в България.
            </p>
            <p>
              Повече реални данни. Повече открити разговори. Повече практически знания. И най-вече —
              събития, на които хората си тръгват с нова перспектива за пазара.
            </p>
            <p>
              Под ръководството на Иво Димовски събитието се развива като национална платформа,
              която свързва инвеститори, купувачи, строители, банки и водещи професионалисти.
            </p>
          </div>

          <a
            href="https://dimovsky.bg/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="organizer-link"
            className="mt-9 inline-flex items-center gap-3 px-7 py-3.5 rounded-full border border-[#F5EBD9]/30 text-[#F5EBD9] font-medium text-sm uppercase tracking-widest hover:bg-[#F5EBD9] hover:text-[#0B1F3D] transition-all"
          >
            Научи повече за Иво
            <ArrowUpRight className="w-4 h-4" strokeWidth={2.4} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
